import React from 'react';
import { Link } from 'react-router-dom';

import Ab2 from '../../images/about/img-3.jpg'
import Ab3 from '../../images/about/img-4.jpg'

const aboutS2 = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="wpo-about-section-s2 section-padding">
            <div className="container">
                <div className="wpo-about-section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-content">
                                <div className="wpo-about-content-top">
                                    <h2>О нас</h2>
                                    <p>AООО "МАРКАЗИ МУТТАХИДАИ ЛОГИСТИКИ" -это транспортная компания, которая  оказывает качественные   услуги  перевозок уже более 5 лет. Мы предлагаем качественную доставку грузов по оптимальным ценам по странам СНГ   и Прибалтики.</p>
                                </div>
                                <div className="wpo-about-check-wrap">
                                    <div className="wpo-about-check-item">
                                        <p>При этом география нашей работы стабильно расширяется и мы рады работать для  вас.</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p>К каждому клиенту компании,предусмотрен индивидуальный подход с учетом оптимизации расходов и предложением лучшего способа доставки грузов.</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p> Услуга компании «от двери до двери» говорит сама за себя включая полный спектр услуг предоставляемых с нашей стороны..</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p>Развитие организации происходит за счет прибыли, без банковских ипотек и займов. Мы выполняем свои обязательства добросовестно перед клиентами а также перед своими подрядчиками, благодаря которым налажено доверительное сотрудничество длинною не в один год</p>
                                    </div>
                                </div>
                                <Link onClick={ClickHandler} to="/service" className="theme-btn-s2">Все услуги</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-img ">
                                <div className="wpo-about-img-left">
                                    <img src={Ab2} alt="" />
                                </div>
                                <div className="about-img-inner">
                                    <img src={Ab3} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default aboutS2;
